import { documentsAndRequests as base } from '../base';
import { documentsAndRequests as AT } from './AT';
import { documentsAndRequests as CZ } from './CZ';
import { documentsAndRequests as HU } from './HU';
import { documentsAndRequests as HR } from './HR';
import { documentsAndRequests as RO } from './RO';
import { documentsAndRequests as SK } from './SK';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    HU,
    HR,
    RO,
    SK,
};
